import "./logout_modal.css";
import { IoClose } from "react-icons/io5";
import Modal from "antd/lib/modal";
import Button from "antd/lib/button";
import { useDispatch, useSelector } from "react-redux";
import { setLogoutModal } from "../../features/app/app_slice";
import { IoCloseCircleOutline } from "react-icons/io5";
import useAuth from "../../hooks/use_auth";

const LogoutModal = () => {
  const dispatch = useDispatch();
  const { logout } = useAuth();

  const logoutModal = useSelector((state) => state.app.logoutModal);
  const logoutLoading = useSelector((state) => state.app.logoutLoading);

  return (
    <Modal
      open={logoutModal}
      onCancel={() => dispatch(setLogoutModal(false))}
      footer={null}
      className={"logoutModal"}
      closeIcon={null}
    >
      <div className={"signOut_modal_container"}>
        <div className={"signOut_modal_title"}>
          <Button
            disabled={logoutLoading}
            onClick={() => dispatch(setLogoutModal(false))}
          >
            <IoClose />
          </Button>
          <IoCloseCircleOutline />
        </div>
        <div>
          <h3>Are you sure you want to log out?</h3>
          <p>
            This will end your session and you'll need to log in again to
            continue.
          </p>
        </div>

        <Button
          className={"confirm_btn"}
          loading={logoutLoading}
          onClick={() => logout()}
        >
          <span>Yes, Log Out</span>
        </Button>
        <Button
          disabled={logoutLoading}
          className={"logout_cancel_btn"}
          onClick={() => dispatch(setLogoutModal(false))}
        >
          <span>Cancel</span>
        </Button>
      </div>
    </Modal>
  );
};

export default LogoutModal;
